<template>
    <div>
        <test-template :testName="testName" :testId="testId" :test="test">
            <template #questions>
                <question-card :question="cQ" v-model="questionResult" :progress="$store.state.tests.currentSlide" :questionnaireLength="$store.state.tests.test.length" @answerQuestion="() => { $store.commit('tests/incrementSlide') }" @submitQuestionnaire="saveTestResults"></question-card>
            </template>
            <template #results>
                <div key="topGraph" class="first">
                    <h3 class="subtitle-card text-center">{{ $t('tests.testResults') }} - {{ testName.toUpperCase() }}</h3>
                </div>
                <div key="recapCard" class="second">
                    
                    <b-card class="neu-card mean-result col-lg-7">
                        <h3 class="subtitle-card"> {{ testName }}</h3>
                        <h5 class="subtitle-card" :style="`color: ${resultInfo.color}`"> {{ resultInfo.tag.toUpperCase() }}</h5>
                        <p class="p-white" v-html="resultInfo.resultsAnalysis"></p>
                    </b-card>
                </div>
                <div v-if="DBResults.generalResult > 0" key="tips" class="third">
                    <h4>{{ $t('tests.results') }} {{ month }}</h4>
                    <div class="col-lg-12 results-container">
                        <p class="card-text text-justify" v-html="$t('tests.nicotine-dependency.tips.general')"></p>
                        <div v-for="t in resultInfo.tips" :key="t.name" class="col-lg-8 results-card">
                            <b-col>
                                <b-card class="neu-card" :title="$t(t.name)">
                                    <p class="card-text text-justify" v-html="$t(t.description)"></p>
                                </b-card>
                            </b-col>
                        </div>
                    </div>
                </div>
            </template>
        </test-template>
    </div>
</template>

<script>
import TestTemplate from './TestTemplate.vue'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import { TEST_NICOTINE_DEPENDENCY } from '@/constants/patientServices'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate
    },
    data () {
        const values = [
            {value: 0, text: this.$t('tests.answers.never')},
            {value: 1, text: this.$t('tests.answers.justsometimes')},
            {value: 2, text: this.$t('tests.answers.sometimes')},
            {value: 3, text: this.$t('tests.answers.alot')},
            {value: 4, text: this.$t('tests.answers.always')}
        ]

        const values2 = [
            {value: 0, text: this.$t('tests.answers.nothingAtAll')},
            {value: 1, text: this.$t('tests.answers.something')},
            {value: 2, text: this.$t('tests.answers.yes')},
            {value: 3, text: this.$t('tests.answers.aLot')},
            {value: 4, text: this.$t('tests.answers.lotsOf')}
        ]

        return {
            test: [],
            values: values,
            values2: values2,
            testId: TEST_NICOTINE_DEPENDENCY,
            testName: this.$t('tests.nicotine-dependency.title')
        }
    },
    created () {
        this.createQuestions()
    },
    methods: {
        createQuestions () {
            const totalQuestions = 11
            for (let i = 1; i <= totalQuestions; i++) {
                this.test.push({
                    id: `q${i}`,
                    question: this.$t(`tests.nicotine-dependency.questions.q${i}`),
                    answer: i === 1 || i === 2 ? this.values2 : this.values,
                    result: null
                })
            }
        },
        saveTestResults () {
            const result = this.test.map(x => x.result).reduce((a, b) => a + b, 0)
            this.save(null, result, this.percentResult(result, 44))
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/NicotineDependencyTest.vue